// extracted by mini-css-extract-plugin
export default {"EmptyParticipantsListMessage":"EmptyParticipantsListMessage-module-f403feb3844be0b1c390"};